import { ResponseError } from '../../errors';
import { prepareBuildersLocations } from '../../mappers/prepareBuildersLocations';
import {
  TGetLocationsListResponse,
  fetchGetLocationsList,
} from '../../repositories/countryside-constructors/v1/get-locations-list';
import { IApplicationContext } from '../../types/applicationContext';
import { ILocationItem } from '../../types/buildersLocations';

export async function fetchBuildersLocations({ httpApi, logger }: IApplicationContext): Promise<ILocationItem[]> {
  try {
    const { response, statusCode }: TGetLocationsListResponse = await fetchGetLocationsList({ httpApi });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchBuildersLocations',
        message: response.message || '',
        details: {
          errors: JSON.stringify(response.errors),
        },
      });
    }

    return prepareBuildersLocations(response);
  } catch (error) {
    logger.warning(error);

    return [];
  }
}
